import { render, staticRenderFns } from "./LegislacoesIndexView.vue?vue&type=template&id=708a9f44&"
import script from "./LegislacoesIndexView.vue?vue&type=script&lang=js&"
export * from "./LegislacoesIndexView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports